import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "organizationRiskScoringRule";

export const useOrganizationRiskScoringRuleStore = defineStore(storeName, () => {
  const all = ref([]);
  const searchQuery = ref(null);

  const { sortedResources } = useFiltering(all, searchQuery, "attributes.createdAt");
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("organization-risk-scoring-rules", errorCallback);
  };

  onMounted(async () => {
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    fetchOrganizationRiskScoringRules: fetchAll,
    searchQuery,
    organizationRiskScoringRules: all,
    sortedOrganizationRiskScoringRules: sortedResources,
  };
});
